<template>
    <div class="footer pl-3 pr-3 fixed-bottom bg-white border-top pt-2 pb-2 shadow-lg small">
        <div class="row">
            <div class="col-10 text-left">
                &copy; {{ new Date().getFullYear() }} - {{ username }}
            </div>
             <div class="col-2 text-right">
                <router-link :to="'/home'" class="text-secondary">
                    <em class="fa fa-home font-weight-bold h5 m-0" ></em>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import api from '../services/api'
import { getUsername, getPerfil } from "../services/api";
import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException } from '../services/exceptions'

export default {
    name: "FooterBar",
    computed: {
        username: function() {
            return getUsername().split(" ")[0];
        },
        perfil: function() {
            return getPerfil();
        },
    },

    data: () => {
        return {
            perfilColetor: 'Aguarde...',
        };
    },

    async mounted() {
        await this.getMenus();
        this.perfilColetor = getPerfil();

        try {
            await this.validarToken();
        } catch (e) {
            if (e instanceof TokenInvalidoException) {
                this.handleTokenInvalidoException();
            } else if (e instanceof ServerErrorException) {
                alert(e.message);
            } else {
                alert(DEFAULT_ERROR_MESSAGE);
            }      
        }
    },

    methods: {
        getPerfil,

        async validarToken() {
            this.carregando = true;

            await api.get("/validar-token");

            this.carregando = false;
        },

        async getMenus() {
            this.carregando = true;

            if (!sessionStorage.getItem("menus")) {
                if (getPerfil() != 'null') {
                    let response = await api.post("/menus", {
                        idPerfil: getPerfil()
                    });

                    this.menus = response.data;
                    sessionStorage.setItem("menus", JSON.stringify(response.data));
                }
            } else {
                this.menus = JSON.parse(sessionStorage.getItem("menus"));
            }
            this.carregando = false;
        },
    }
};
</script>